import { createRouter, createWebHistory } from 'vue-router'
import AppHeader from "@/layout/AppHeader.vue";
import AppFooter from "@/layout/AppFooter";
import Components from "../views/Components.vue";
import YunusRajabiy from '@/components/YunusRajabiy.vue';
import Aloqa from '@/components/Aloqa.vue';
import Real from '@/components/Real.vue';

const routes = [
  {
    path: "/",
    name: "components",
    meta: { redirectIfLoggedIn: true },
    components: {
      header: AppHeader,
      default: Components,
      footer: AppFooter,
    }
  },

  {
    path: "/YunusRajabiy",
    name: "YunusRajabiy",
    meta: { redirectIfLoggedIn: true },
    components: {
      header: AppHeader,
      default: YunusRajabiy,
      footer: AppFooter,
    }
  },

  {
    path: "/Vertual",
    name: "Vertual",
    meta: { redirectIfLoggedIn: true },
    components: {
      header: AppHeader,
      default: Real,
      footer: AppFooter,
    }
  },

  {
    path: "/Aloqa",
    name: "Aloqa",
    meta: { redirectIfLoggedIn: true },
    components: {
      header: AppHeader,
      default: Aloqa,
      footer: AppFooter,
    }
  },

  

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),

  scrollBehavior: () => ({
    y: 0,
    x: 0,
  }),
  routes
})



router.beforeEach((to, from, next) => {
  if (to.path !== '/' && !to.meta.redirectIfLoggedIn) {
    if (localStorage.getItem('user_info')) {
      next();
    } else {
      next('/');
    }
  } else {
    next();
  }
});

export default router
